export default {
  message: {
    hello: '你好'
  },
}
